export const AMBASSADOR_API_BASE_URL =
  import.meta.env.VITE_AMBASSADOR_API_BASE_URL ||
  "https://xpress-ambassador-api-staging.xlnsports.workers.dev";
